export const baseSize = 16;

const pxToRem = (px: number) => {
  return `${px / 16}rem`;
};

export default pxToRem;
